
<template>
   <div>
    <div
      class="d-flex justify-content-end mb-3"
      style="gap: 1rem">
      <d-button
        v-if="isPreview"
        theme="primary"
        @click.prevent="requestClientsListPreview">
        <i class="material-icons">preview</i>
        {{ $t('marketing.preview10Results') }}
      </d-button>
      <template v-else>
        <d-button
          theme="primary"
          @click.prevent="loadClientsList">
          <i class="material-icons">refresh</i>
          {{ $t('marketing.reloadClientsList') }}
        </d-button>
        <d-button
          theme="warning"
          @click.prevent="rebuildClientsList">
          <i class="material-icons">update</i>
          {{ $t('marketing.rebuildClientsList') }}
        </d-button>
      </template>
    </div>

    <d-alert
      v-if="isFormInvalid"
      show
      theme="warning"
      class="mb-4">
      {{ $t('marketing.segmentFormValidationError') }}
    </d-alert>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
    </d-alert>
    <table
      v-else-if="isAfterFirstFetch"
      class="table mt-0 mb-0 full-width">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">ID</th>
          <th scope="col" class="border-0">{{ $t('order.creationDate') }}</th>
          <th scope="col" class="border-0">{{ $t('ui.name') }}</th>
        </tr>
      </thead>
      <tbody v-if="loaded">
        <tr
          v-for="(client, index) of customersList"
          :key="'client-' + index">
          <td class="align-middle">
            {{ client.id }}
          </td>
          <td class="align-middle">
            {{ formatDate(client.created_at) }}
          </td>
          <td class="align-middle">
            {{ client.name }}
          </td>
        </tr>
        <tr v-if="customersList.length === 0">
          <td
            colspan="3"
            class="text-center">
            {{ $t('marketing.noMatchingCustomersFound') }}&hellip;
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="!loadError && !loaded"
      class="pb-3 pt-3 text-center">
      {{ $t('ui.dataLoading') }}&hellip;
    </div>
   </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils.js';
import CalendarUtils from '@/utils/CalendarUtils';

export default {
  name: 'segment-results',
  props: {
    formErrors: {
      required: true,
      type: Object
    },
    isFormInvalid: {
      default: false,
      type: Boolean
    },
    isPreview: {
      default: false,
      type: Boolean
    },
    segmentData: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      isAfterFirstFetch: false,
      loaded: true,
      loadError: false,
      customersList: []
    }
  },
  mounted () {
    if (!this.isPreview) {
      this.loadClientsList();
    }
  },
  methods: {
    requestClientsListPreview () {
      this.$emit('validate-before-preview', this.loadClientsListPreview);
    },
    loadClientsListPreview () {
      this.loaded = false;
      this.isAfterFirstFetch = true;
      FormUtils.loadAdditionalData(this, {
        method: 'post',
        endpoint: '/marketing/segments/preview-customers',
        params: this.segmentData,
        loadedKey: 'loaded',
        outputKey: 'customersList',
        errorKey: 'loadError',
      });
    },
    loadClientsList () {
      this.loaded = false;
      this.isAfterFirstFetch = true;
      ListUtils.loadItemsData(
        this,
        '/marketing/segments/customers/items',
        'customersList',
        { segment_id: this.segmentData.id },
        'post'
      );
    },
    rebuildClientsList () {
      this.loaded = false;

      this.$http.post('/marketing/segments/rebuild-customers/' + parseInt(this.segmentData.id, 10))
        .then(() => {
          this.loadClientsList();
        })
        .catch(error => {
          console.log(error);
          this.loadError = true;
          this.loaded = true;
        });
    },
    formatDate (date) {
      if (!date) {
        return '-';
      }
      return CalendarUtils.formatDateForPHP(new Date(date));
    },
  }
}
</script>
